export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return

  const store = useAuthStore()
  const { loggedIn } = storeToRefs(store)

  if (!loggedIn.value) store.loadUserSession()
})
